/* eslint jsx-a11y/anchor-is-valid: 0 */
import React, { Component, useEffect } from "react";
import firebase from 'firebase/compat/app';
import { getUserLocale } from 'get-user-locale';
import {
  Container,
  Row,
  Col,
  Card,
  Button, Form, FormInput, FormGroup, FormFeedback
} from "shards-react";
import { WEBSITE_URL } from "../../environmentVariables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useAnimation } from "../../contexts/AnimationContext";
import { useNavigate } from "react-router-dom";

const language = (getUserLocale() && getUserLocale().length === 5) ? getUserLocale() : 'en_US';
const locale = language.substr(-2).toLowerCase();

// Animation wrapper component
const AnimatedForgotPasswordWrapper = (props) => {
  const { animationDirection, setDirection } = useAnimation();
  const navigate = useNavigate();
  
  // When component mounts, check if we need to animate
  useEffect(() => {
    if (animationDirection === 'to-forgot') {
      // Reset after animation completes
      setTimeout(() => {
        setDirection('none');
      }, 100);
    }
  }, [animationDirection, setDirection]);
  
  const goToLogin = (e) => {
    if (e) e.preventDefault();
    setDirection('to-login');
    setTimeout(() => {
      navigate('/login');
    }, 300); // Transition duration
  };
  
  return <ForgotPasswordComponent {...props} animationDirection={animationDirection} goToLogin={goToLogin} />;
};

class ForgotPasswordComponent extends Component {
  constructor(props) {
    super(props)
  }

  state = {
    email: null,
    sentPassword: false,
  };

  render() {
    const { animationDirection, goToLogin } = this.props;
    const animationClass = animationDirection === 'to-forgot' ? 'slide-in-right' : 
                          animationDirection === 'to-login' ? 'slide-out-right' : '';
    
    return (
      <Container fluid className="px-0 forgot-password-container">
        <style>
        {`
          .forgot-password-container {
            background: linear-gradient(135deg, #f8f9fe 0%, #eef1f8 100%);
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
          }
          
          .forgot-password-card {
            border-radius: 12px;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
            border: none;
            overflow: hidden;
            max-width: 450px;
            margin: 2rem auto;
            background: white;
            transition: transform 0.3s ease, opacity 0.3s ease;
          }
          
          .forgot-password-header {
            background: linear-gradient(135deg, #21AA73 0%, #19af75 100%);
            padding: 2rem;
            text-align: center;
            margin-bottom: 1.5rem;
          }
          
          .forgot-password-logo {
            width: 180px;
            filter: brightness(0) invert(1);
            margin-bottom: 1rem;
          }
          
          .title-text {
            color: white;
            font-size: 1.2rem;
            font-weight: 300;
            margin-bottom: 0;
          }
          
          .forgot-password-form {
            padding: 0 2rem 2rem;
          }
          
          .form-label {
            font-size: 0.7rem;
            text-transform: uppercase;
            letter-spacing: 0.7px;
            font-weight: 600;
            color: #495057;
            margin-bottom: 0.5rem;
          }
          
          .input-with-icon {
            position: relative;
          }
          
          .input-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #B3B5B9;
          }
          
          .form-input-styled {
            padding-left: 40px;
            height: 46px;
            border-radius: 8px;
            border: 1px solid #e1e5eb;
            font-size: 0.95rem;
            transition: all 0.2s ease;
          }
          
          .form-input-styled:focus {
            border-color: #21AA73;
            box-shadow: 0 0 0 0.2rem rgba(33, 170, 115, 0.25);
          }
          
          .action-btn {
            height: 46px;
            border-radius: 8px;
            font-weight: 500;
            font-size: 0.95rem;
            transition: all 0.2s ease;
            margin-top: 1rem;
            box-shadow: 0 4px 12px rgba(33, 170, 115, 0.2);
          }
          
          .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 15px rgba(33, 170, 115, 0.25);
          }
          
          .forgot-password-footer {
            margin-top: 1.5rem;
            text-align: center;
          }
          
          .footer-links {
            display: flex;
            justify-content: center;
            margin-bottom: 1rem;
          }
          
          .footer-link {
            color: #6c757d;
            font-size: 0.8rem;
            margin: 0 0.75rem;
            transition: color 0.2s;
          }
          
          .footer-link:hover {
            color: #21AA73;
            text-decoration: none;
          }
          
          .copyright {
            color: #9EA0A5;
            font-size: 0.75rem;
          }
          
          /* Animation classes */
          .slide-in-right {
            animation: slideInRight 0.3s forwards;
          }
          
          .slide-out-right {
            transform: translateX(100px);
            opacity: 0;
          }
          
          @keyframes slideInRight {
            from {
              transform: translateX(100px);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          
          @media (max-width: 576px) {
            .forgot-password-card {
              margin: 1rem;
              max-width: none;
            }
            
            .forgot-password-header {
              padding: 1.5rem;
            }
            
            .forgot-password-form {
              padding: 0 1.5rem 1.5rem;
            }
          }
        `}
        </style>
        
        <Row className="mx-0 w-100">
          <Col md="10" lg="8" xl="6" className="mx-auto">
            <Card className={`forgot-password-card ${animationClass}`}>
              <div className="forgot-password-header">
                <img 
                  src={require('../../images/enforceplus-logo.png')}
                  alt="EnforcePlus"
                  className="forgot-password-logo"
                />
                <p className="title-text">
                  {this.state.sentPassword 
                    ? "Password Reset Sent" 
                    : "Reset Your Password"}
                </p>
              </div>
              
              <div className="forgot-password-form">
                {this.state.sentPassword ? (
                  <div className="text-center mb-4">
                    <p>A password reset link has been sent to your email address. Please check your inbox and follow the instructions.</p>
                    <Button
                      theme="accent"
                      className="action-btn w-100 d-flex align-items-center justify-content-center mt-4"
                      onClick={goToLogin}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                      Back to Sign In
                    </Button>
                  </div>
                ) : (
                  <Form>
                    <p className="text-muted mb-4">Enter your email address below and we'll send you instructions to reset your password.</p>
                    <FormGroup>
                      <label className="form-label">Email Address</label>
                      <div className="input-with-icon">
                        <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                        <FormInput 
                          id="email"
                          className="form-input-styled"
                          placeholder="Enter your email"
                          onChange={event => this.setState({email: event.target.value})}
                        />
                      </div>
                    </FormGroup>
                    
                    <FormGroup>
                      <Button
                        theme="accent"
                        className="action-btn w-100"
                        onClick={() => {
                          this.props.sendPasswordResetEmail(this.state.email);
                          this.setState({sentPassword: true})
                        }}
                        disabled={!this.state.email}
                      >
                        Reset Password
                      </Button>
                    </FormGroup>
                    
                    <div className="text-center mt-3">
                      <a href="#" onClick={goToLogin} className="text-primary">Remembered your password? Sign in</a>
                    </div>
                  </Form>
                )}
              </div>
            </Card>
            
            <div className="forgot-password-footer">
              <div className="footer-links">
                <a href={`${WEBSITE_URL}/terms`} target="_blank" rel="noopener noreferrer" className="footer-link">Terms of Use</a>
                <a href={`${WEBSITE_URL}/privacy`} target="_blank" rel="noopener noreferrer" className="footer-link">Privacy Policy</a>
                <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer" className="footer-link">Website</a>
              </div>
              <div className="copyright">&copy; {new Date().getFullYear()} EnforcePlus LLC</div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AnimatedForgotPasswordWrapper;
